export class Settings {
    public static ApiUrl: string = process.env.VUE_APP_APIURL;
}